/**
 * The admin user page's "Match pool" line (view core.match_pool_tiers, migration 390,
 * owner decision 2026-10-26): 5 shown matches in a row with no app open → Restricted
 * (matched on Mondays only); Restricted and no app open for 90 days → Dormant (not
 * matched); any app open → Active.
 */
export type MatchPoolTier = 'active' | 'restricted' | 'dormant';

/** One plain line for the tier, with the count that put the member there. */
export function describeMatchPoolTier(tier: MatchPoolTier, streak: number): string {
  const unopened = `${streak} unopened ${streak === 1 ? 'match' : 'matches'} in a row`;
  if (tier === 'restricted') return `Restricted — matched on Mondays only (${unopened})`;
  if (tier === 'dormant') return `Dormant — not matched (no app open for 90+ days; ${unopened})`;
  return streak > 0 ? `Active (${unopened})` : 'Active';
}
